import { assertRelativeImagePaths, normalizeCatalogEntity, normalizeListEnvelope } from './catalog.mjs'

function cleanParams(params = {}) {
  return Object.entries(params).reduce((result, [key, value]) => {
    if (value !== '' && value !== null && value !== undefined) result[key] = value
    return result
  }, {})
}

function listParams(params = {}) {
  return cleanParams({ ...params, lang: 'uk' })
}

function productPayload(payload) {
  const result = { ...payload }
  if (Array.isArray(result.images) && result.images.length === 0) delete result.images
  else if (Object.prototype.hasOwnProperty.call(result, 'images')) result.images = assertRelativeImagePaths(result.images)
  return result
}

export function createCatalogApi(client) {
  const list = async (path, params = {}) => normalizeListEnvelope((await client.get(path, { params: listParams(params) })).data)
  const get = async (path) => normalizeCatalogEntity((await client.get(path)).data)
  const create = async (path, payload) => normalizeCatalogEntity((await client.post(path, payload)).data)
  const update = async (path, payload) => normalizeCatalogEntity((await client.put(path, payload)).data)

  return {
    listProducts: (params = {}) => list('/products', params),
    getProduct: (id) => get(`/products/${encodeURIComponent(id)}`),
    createProduct: (payload) => create('/products', productPayload(payload)),
    updateProduct: (id, payload) => update(`/products/${encodeURIComponent(id)}`, productPayload(payload)),
    deleteProduct: (id) => client.delete(`/products/${encodeURIComponent(id)}`),
    listProviders: (params = {}) => list('/providers', params),

    listCategories: (params = {}) => list('/category', params),
    getCategory: (id) => get(`/category/${encodeURIComponent(id)}`),
    createCategory: (payload) => create('/category', payload),
    updateCategory: (id, payload) => update(`/category/${encodeURIComponent(id)}`, payload),
    deleteCategory: (id) => client.delete(`/category/${encodeURIComponent(id)}`),

    listBrands: (params = {}) => list('/brand', params),
    getBrand: (id) => get(`/brand/${encodeURIComponent(id)}`),
    createBrand: (payload) => create('/brand', payload),
    updateBrand: (id, payload) => update(`/brand/${encodeURIComponent(id)}`, payload),
    deleteBrand: (id) => client.delete(`/brand/${encodeURIComponent(id)}`),

    listCharacteristics: (params = {}) => list('/characteristics', params),
    getCharacteristic: (id) => get(`/characteristics/${encodeURIComponent(id)}`),
    createCharacteristic: (payload) => create('/characteristics', payload),
    updateCharacteristic: (id, payload) => update(`/characteristics/${encodeURIComponent(id)}`, payload),
    deleteCharacteristic: (id) => client.delete(`/characteristics/${encodeURIComponent(id)}`),

    async getCategoryCharacteristics(categoryId, { localOnly = false } = {}) {
      const path = `/category/${encodeURIComponent(categoryId)}/characteristics`
      const response = localOnly ? await client.get(path, { params: { localOnly: 1 } }) : await client.get(path)
      return normalizeListEnvelope(response.data)
    },
    assignCharacteristic: async (categoryId, characteristicId, sortOrder) => normalizeCatalogEntity((await client.put(
      `/category/${encodeURIComponent(categoryId)}/characteristics/${encodeURIComponent(characteristicId)}`,
      { sortOrder: Number(sortOrder) },
    )).data),
    deleteAssignment: (categoryId, characteristicId) => client.delete(
      `/category/${encodeURIComponent(categoryId)}/characteristics/${encodeURIComponent(characteristicId)}`,
    ),

    async getProductValues(productId) {
      return normalizeListEnvelope((await client.get(`/products/${encodeURIComponent(productId)}/characteristics`)).data)
    },
    putProductValue: async (productId, characteristicId, translations) => normalizeCatalogEntity((await client.put(
      `/products/${encodeURIComponent(productId)}/characteristics/${encodeURIComponent(characteristicId)}`,
      { translations },
    )).data),
    deleteProductValue: (productId, characteristicId) => client.delete(
      `/products/${encodeURIComponent(productId)}/characteristics/${encodeURIComponent(characteristicId)}`,
    ),
  }
}
